import React from 'react';
import moment from 'moment';
import validator from 'validator';
import { AFSP } from 'utils/reqUtils';
import { doRequest } from 'services/appService';
import { Row, Col, Select, DatePicker, Checkbox, Form, Input } from 'antd';
import { ssCommonUtils, ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';

const { getDataType } = ssCommonUtils;

// Used to bind all the functions required for inputs to
// work according to the way this code is currently working.
// However, if time ever permits, a refactor of the way forms
// are handled should be changed.
export function formHook(type) {
    this.getProps = {};

    if(type === 'registration') {
        for(var p in getProps.registration)
            this.getProps[p] = getProps.registration[p].bind(this);
    } else if(type === 'login') {
        for(var p in getProps.login)
            this.getProps[p] = getProps.login[p].bind(this);
    }

    this.getComponentState = getComponentState.bind(this);
    this.asyncValidation = asyncValidation.bind(this);
    this.linkValidation = linkValidation.bind(this);
    this.setFieldState = setFieldState.bind(this);
    this.onUpdate = onUpdate.bind(this);
    this.setField = setField.bind(this);
    this.state = getComponentState();
}

export const FORM = {
    TYPES: {
        FIRST_GIVEN_NAME: 'firstGivenName',
        MIDDLE_NAME: 'middleName',
        LAST_FAMILY_SURNAME: 'lastFamilySurname',
        NAME_SUFFIX: 'nameSuffix',
        DATE_OF_BIRTH: 'dateOfBirth',
        DATE_OF_BIRTH_IS: 'dateOfBirthIs',
        PHONE_NUMBER: 'phoneNumber',
        PASSPORT_TYPE: 'passportType',
        PASSPORT_NUMBER: 'passportNumber',
        ISSUE_DATE: 'issueDate',
        EXPIRATION_DATE: 'expirationDate',
        ISSUING_COUNTRY: 'issuingCountry',
        CITY: 'city',
        ISSUED_OUTSIDE_ISSUING_COUNTRY: 'issuedOutsideIssuingCountry',
        PASSPORT_RENEWED: 'passportRenewed',
        USER_ID: 'userId',
        EMAIL_ADDRESS: 'emailAddress',
        OLD_EMAIL_ADDRESS: 'oldEmailAddress',
        NEW_EMAIL_ADDRESS: 'newEmailAddress',
        VERIFY_EMAIL_ADDRESS: 'verifyEmailAddress',
        CITY_BORN: 'cityBorn',
        FAVORITE_FOOD: 'favoriteFood',
        FAVORITE_COLOR: 'favoriteColor',
        UNDERSTAND_AND_AGREE: 'understandAndAgree',
        FULL_NAME: 'fullName',
        VERFICATION_CODE: 'verficationCode',
        CAPTCHA: 'captcha',
        CAPTCHA_BASE64: 'captchaBase64',
        PASSWORD: 'password',
        FSDO: 'fsdo',
        PROVIDER_NAME: 'providerName',
        PROVIDER_STATE: 'providerState',
        PROVIDER_TYPE: 'providerType',
        CERT_DESIGNATOR: 'certDesignator',
        CONSENT: 'consent'
    }
}

export const COUNTRIES = [
    { abr: "AFG", country: "Afghanistan" },
    { abr: "ALB", country: "Albania" },
    { abr: "DZA", country: "Algeria" }
]

export const PROVIDER_SELECTION_MAPPER = {
    FLIGHT_TRAINING_PROVIDER_TYPE: {
        AIR_CARRIER: 'Air Carrier',
        INDIVIDUAL_CFI: 'Individual Cfi',
        OTHER: 'Other -- not in list --',
        PART_141: 'Part 141',
        PART_142: 'Part 142',
        PART_61: 'Part 61'
    }
}

export function getSelectionMapperProp(t, v) {
    var
    result,
    match = false,
    iterator = (o) => {
        for(var a in o) {
            switch(getDataType(t[p])) {
                case 'Object':
                    iterator(o[a]);
                case 'String':
                    match = true;
                    if(a === v) result = v;
                    break;
            }
            if(match) break;
        }
    };

    iterator(t);
    return result;
}

export function generateState(config) {
    var
    result = {},
    matchSet = [ 'validation', 'link', 'async', 'minLength' ],
    overwriteSet = [ FORM.TYPES.CAPTCHA_BASE64 ],
    hasMatch = (target, matchSet) => {
        for(var i=0; i<matchSet.length; i++)
            if(target === matchSet[i]) return true;
        return false;
    }

    config.forEach((item, index) => {
        var hasRequired = false;
        result[item.ref] = {
            form: {
                validateStatus: '',
                help: ''
            },
            value: getDefaultValue(item.ref),
            valid: false
        };
        for(var p in item) {
            if(p !== 'ref') {
                if(hasMatch(p, matchSet)) result[item.ref][p] = item[p];
                else {
                    if(p === 'required') hasRequired = true;
                    result[item.ref].form[p] = item[p];
                }
            }
        }
        if(!hasRequired) result[item.ref].form.required = true;

        // Overwrite the 'item.ref' prop in 'result' with an empty string
        // if the 'ref' is of a particular type.
        for(var p in overwriteSet) {
            if(item.ref === p) {
                result[item.ref] = '';
                break;
            }
        }
    });

    return result;
}

export const getProps = {
    registration: {
        input: function(field, title) {
            const
            { setField, onUpdate } = this,
            { state } = this.props;
            return {
                placeholder: title,
                value: state[field].value,
                'onFocus': function() { setField(field); },
                // 'onBlur': function(e) { onUpdate(e, EVENT_TYPES.ON_BLUR); },
                'onChange': function(e) { onUpdate(e); }
            };
        },
        selection: function(field, title) {
            const
            { setField, onUpdate } = this,
            { state } = this.props;
            return {
                mode: 'combobox',
                placeholder: title,
                value: state[field].value,
                'onFocus': function() { setField(field); },
                'onChange': function(e) { onUpdate(e); }
            }
        },
        datePicker: function(field) {
            const
            { setField, onUpdate } = this,
            { state } = this.props;
            return {
                value: moment(state[field].value, 'YYYY-MM-DD'),
                allowClear: false,
                format: 'YYYY-MM-DD',
                style: { width: '200px' },
                'onFocus': function() { setField(field); },
                'onChange': function(date, str) {
                    onUpdate({ date: date, str: str });
                }
            };
        },
        checkbox: function(field) {
            const
            { setField, onUpdate } = this,
            { state } = this.props;
            return {
                checked: state[field].value,
                'onFocus': function() { setField(field); },
                'onChange': function(e) { onUpdate(e); }
            }
        }
    },
    login: {
        username: function(field, title, icon) {
            const
            { setField, onUpdate } = this,
            { state } = this.props;
            return {
                prefix: icon,
                placeholder: title,
                value: state[field].value,
                'onFocus': function() { setField(field) },
                'onChange': function(e) { onUpdate(e); }
            }
        },
        password: function(field, title, icon) {
            const
            { setField, onUpdate } = this,
            { state } = this.props;
            return {
                prefix: icon,
                type: 'password',
                placeholder: title,
                value: state[field].value,
                'onFocus': function() { setField(field); },
                'onChange': function(e) { onUpdate(e); }
            }
        }
    }
}

export function getComponentState() {
    return { field: '' };
}

export function setField(field) {
    this.setState({...this.state, field: field});
}

export function onUpdate(e) {
    var
    value,
    validatedResult,
    allowExecution = true,
    { field } = this.state,
    { state } = this.props,
    target = state[field];

    if(isDateField(field)) value = e.str;
    else if(isSelectField(field)) value = e;
    else if(isCheckbox(field)) value = e.target.checked;
    else value = e.target.value;

    if(target.hasOwnProperty('link'))
        this.setFieldState(target, this.linkValidation(validate(value, target)));
    else
        this.setFieldState(target, validate(value, target));

    if(target.hasOwnProperty('async'))
        if(target.valid && target.async.active)
            this.asyncValidation(target);
}

export function asyncValidation(target) {
    const
    { asyncService } = this.props,
    { field } = this.state,
    { value } = target,
    { request, type, stateRef, help } = target.async;

    var
    asyncData = {
        stateReference: (stateRef + '.' + field),
        help: help,
        type: type,
        value: value
    },
    conditional = validCondition('minLength', 'pass', target, {...target.form, value: target.value });

    if(conditional) asyncService(request, asyncData);
    else if(conditional == null) asyncService(request, asyncData);
}

export function linkValidation(validationResult) {
    const
    { field } = this.state,
    { sref, state, service } = this.props,
    target = state[field];

    if(validationResult.valid && target.hasOwnProperty('link')) {
        var linkValidation = {}, allLinksValid = true;
        for(var i=0; i<target.link.length; i++) {
            var linkedField = state[target.link[i]];
            if(linkedField.value !== validationResult.value) linkValidation[target.link[i]] = false;
            else linkValidation[target.link[i]] = true;
        }
        for(var p in linkValidation) {
            if(!linkValidation[p]) {
                allLinksValid = false;
                service(sref, {...state,
                    [p]: {...state[p],
                        valid: false,
                        form: {...state[p].form,
                            help: 'Fields do not match.',
                            validateStatus: 'warning'
                        }
                    }
                });
            } else {
                if(state[p].form.validateStatus === 'warning') {
                    this.setFieldState(state[p], validate(state[p].value, state[p]));
                }
            }
        }
        if(allLinksValid) return validationResult;
        else return {...validationResult,
            help: 'Fields do not match.',
            valid: false,
            validateStatus: 'warning'
        };
    } else return validationResult;
}

export function validate(data, state) {
    const { validateOrArgs } = extendedValidation;
    var validation = state.validation || [], result = {}, error = {};

    // This should only affect checkboxes, the data passed in by
    // a checkbox is either 'true' or 'false'.
    if(typeof(data) === "boolean") {
        const { required } = state.form;
        if(required && !data) {
            result = getRequired(true);
            result.value = data;
            return result;
        } else if(required && data) {
            return {
                valid: true,
                value: data,
                help: '',
                validateStatus: 'success'
            };
        }
    }

    if(data != null && data != undefined && data !== '') {
        for(var i=0; i<validation.length; i++) {
            var func, orArgs = (validation[i].match(/\|/g) || []).length;

            // Validate that at least one function returns positive.
            if(orArgs > 0) result.or = validateOrArgs(validation[i], data, state);
            else {
                func = 'is' + (validation[i].charAt(0).toUpperCase() + validation[i].slice(1));
                result[validation[i]] = formValidation[func](data, state);
            }
        }
    } else {
        // Return the error is empty.
        error = getRequired(state.form.required);
        error.value = data;
        return error;
    }

    // If not empty and there is an error, grab the error and return it.
    for(var p in result) {
        if(!result[p].valid) {
            error = result[p];
            error.value = data;
            return error;
        }
    }

    // Getting here assumes everything was good, no errors. Return
    // based on the is the state required this field or not.
    return { valid: true, value: data, help: '', validateStatus: 'success' };
}

export function setFieldState(target, data) {
    var { service, state, sref } = this.props;

    if(data.valid) {
        if(validCondition('minLength', 'fail', target, data))
            data.help = 'Minimum characters ' + (target.minLength) + '.';
    }

    if(data.hasOwnProperty('validateStatus')) {
        var { validateStatus } = data;
        target.form.validateStatus = setValidationStatus(validateStatus);
    }

    if(data.hasOwnProperty('help'))  target.form.help = data.help;
    if(data.hasOwnProperty('value')) target.value = data.value;
    if(data.hasOwnProperty('valid')) target.valid = data.valid;

    service(sref, state);
}

export function formConfigBuilder(state, configArray) {
    var result = {};
    for(var i=0; i<configArray.length; i++) {
        var
        ref = configArray[i],
        conf = result[ref.field] = {};
        conf.state = state[ref.field];
        for(var p in ref) conf[p] = ref[p];
    }
    return result;
}

export function formItemGenerator(config) {
    const
    { type, label, style, field, placeholder } = config,
    { form } = config.state,
    { input } = this.getProps;

    var formItemProps = {...form,
        label: label,
        style: style
    }, component;

    switch(type) {
        case 'input':
            component = (<Input {...input(field, placeholder)} />);
            break;
    }

    return (<Form.Item {...formItemProps} hasFeedback>{component}</Form.Item>);
}

// Controls the 'autoPopulate' execution.
const allowAutoPopulating = false;

// When using this, you want to make sure you bind the scope so it
// properly simulates the scope with the rest of the funcitons that
// this event function calls.
export function autoPopulate(data) {
    if(allowAutoPopulating)
        for(var i=0; i<data.length; i++) {
            this.setField(data[i][0]);
            this.onUpdate(data[i][1]);
        }
}

// Controls the stepper to allow automated stepping.
export function autoStepper(steps) {
    if(allowAutoPopulating)
        for(var i=0; i<steps; i++) setTimeout(() => { this.stepChange('next'); }, 0);
}

// +------------------------------+
// |           INTERNAL           |
// +------------------------------+

function setValidationStatus(status) {
    switch(status) {
        case 'validating': return 'validating'; break;
        case 'success':    return 'success';    break;
        case 'warning':    return 'warning';    break;
        case 'error':      return 'error';      break;
        case '':           return '';           break;
    }
}

function validCondition(condition, type, target, data) {
    switch(condition) {
        case 'minLength':
            if(target.hasOwnProperty(condition))  {
                var value = data.value;
                if(typeof data.value === 'string') {
                    var length = value.length, minLength = target.minLength;
                    if(type === 'pass') {
                        if(length < minLength && length > 0) return false;
                        else return true;
                    } else if(type === 'fail') {
                        if(length < minLength && length > 0) return true;
                        else return false;
                    }
                };
            }
            return null;
    }
}

const EVENT_TYPES = {
    ON_BLUR: 'onBlur',
    ON_CLICK: 'onClick'
}

const extendedValidation = {
    validateOrArgs: (str, data, state) => {
        var orIndexes = [], funcs = [], results = [];

        // Get all the indexes.
        for(var j=0; j<str.length; j++) if(str[j] === '|') orIndexes.push(j);

        for(var j=0; j<orIndexes.length; j++) {
            if(j > 0) funcs.push(str.substring(orIndexes[(j-1)] + 1, orIndexes[j]));
            else funcs.push(str.substring(0, orIndexes[j]));
        }

        // Grab the last section of the indexes, if it exists.
        if(orIndexes[orIndexes.length-1] < str.length-1)
            funcs.push(str.substring(orIndexes[orIndexes.length-1] + 1, str.length));

        for(var j=0; j<funcs.length; j++) {
            var func = 'is' + (funcs[j].charAt(0).toUpperCase() + funcs[j].slice(1));
            results.push(formValidation[func](data, state));
        }

        // Return if at least one of them is 'true'.
        for(var j=0; j<results.length; j++)
            if(results[j].valid) return { valid: true };

        // Getting this far means there is an error.
        // Get the first error in the array and return that.
        for(var j=0; j<results.length; j++)
            if(!results[j].valid) return results[j];
    },
    // The modder is only meant to run sanitization on input, after validation.
    modder: (data, state) => {
        if(state.hasOwnProperty('mod')) {
            var { mod } = state;
            return {...data, value: formModder[mod](data.value) };
        }
    }
}

const MESSAGES = {
    REQUIRED: 'This field is requied.',
    ALPHABETIC_MESSAGE: 'Enter only letters.',
    ALPHANUMERIC_MESSAGE: 'Enter only letters or numbers.',
    EMAIL_MESSAGE: 'Must be an email.',
    PHONE_NUMBER_MESSAGE: 'Must be a phone number.',
    IN_PAST_MESSAGE: 'Should be in the past.',
    IN_FUTURE_MESSAGE: 'Should be in the future.'
}

export function getDefaultValue(type) {
    if(isDateField(type)) return moment();
    else if(isCheckbox(type)) return false;
    else return '';
}

// Just checks the 'field' to see if it is one of these
// DatePicker fields. If it is it grabs the value from 'e'
// differently by returning 'true'.
function isDateField(type) {
    const { DATE_OF_BIRTH, ISSUE_DATE, EXPIRATION_DATE } = FORM.TYPES;

    var dateFields = [
        DATE_OF_BIRTH,
        ISSUE_DATE,
        EXPIRATION_DATE
    ]

    for(var i=0; i<dateFields.length; i++) if(type === dateFields[i]) return true;
    return false;
}

// Same as 'isDateField' but for selection dropdowns.
function isSelectField(type) {
    const { DATE_OF_BIRTH_IS, NAME_SUFFIX, PASSPORT_TYPE, ISSUING_COUNTRY, PROVIDER_TYPE, FSDO, PROVIDER_STATE } = FORM.TYPES;

    var selectFields = [
        DATE_OF_BIRTH_IS,
        NAME_SUFFIX,
        PASSPORT_TYPE,
        ISSUING_COUNTRY,
        PROVIDER_TYPE,
        FSDO,
        PROVIDER_STATE
    ]

    for(var i=0; i<selectFields.length; i++) if(type === selectFields[i]) return true;
    return false;
}

function isCheckbox(type) {
    const { ISSUED_OUTSIDE_ISSUING_COUNTRY, PASSPORT_RENEWED, UNDERSTAND_AND_AGREE, CONSENT } = FORM.TYPES;

    var checkboxFields = [
        ISSUED_OUTSIDE_ISSUING_COUNTRY,
        PASSPORT_RENEWED,
        UNDERSTAND_AND_AGREE,
        CONSENT
    ]

    for(var i=0; i<checkboxFields.length; i++) if(type === checkboxFields[i]) return true;
    return false;
}

function getRequired(required) {
    if(required) return { valid: false, help: MESSAGES.REQUIRED, value: '', validateStatus: 'error' }
    else return { valid: true, help: '', value: '', validateStatus: '' };
}

function getError(msg) {
    return {
        help: msg,
        valid: false,
        validateStatus: 'error'
    }
}

const formValidation = {
    isName: (data, state) => {
        const { ALPHABETIC_MESSAGE } = MESSAGES;
        if(validator.matches(data, /^[a-z \.\,\+\-]*$/i)) return { valid: true };
        else return getError(ALPHABETIC_MESSAGE);
    },
    isAlphabetic: (data, state) => {
        const { ALPHABETIC_MESSAGE } = MESSAGES;
        if(validator.isAlpha(data, 'en-US')) return { valid: true };
        else return getError(ALPHABETIC_MESSAGE);
    },
    isAlphanumeric: (data, state) => {
        const { ALPHANUMERIC_MESSAGE } = MESSAGES;
        if(validator.isAlphanumeric(data, 'en-US')) return { valid: true };
        else return getError(ALPHANUMERIC_MESSAGE);
    },
    isEmail: (data, state) => {
        const { EMAIL_MESSAGE } = MESSAGES;
        if(validator.isEmail(data)) {
            return { valid: true };
        } else return getError(EMAIL_MESSAGE);
    },
    isPhone: (data, state) => {
        const { PHONE_NUMBER_MESSAGE } = MESSAGES;
        if(validator.isMobilePhone(data, 'en-US')) return { valid: true };
        else return getError(PHONE_NUMBER_MESSAGE);
    },
    isPast: (data, state) => {
        const { IN_PAST_MESSAGE } = MESSAGES;

        var now = moment.utc(), date = moment.utc(data);
        now = now.clone().utc().startOf('day');

        if(now < date) return getError(IN_PAST_MESSAGE);
        else return { valid: true };
    },
    isFuture: (data, state) => {
        const { IN_FUTURE_MESSAGE } = MESSAGES;

        var now = moment.utc(), date = moment.utc(data);
        now = now.clone().utc().startOf('day');

        if(now > date) return getError(IN_FUTURE_MESSAGE);
        else return { valid: true };
    }
}

const formModder = {
    sanitizer: (data) => {
        return validator.escape(data);
    }
}
